import { render, staticRenderFns } from "./InsertSlideScope.vue?vue&type=template&id=5e01aa07&lang=pug"
import script from "./InsertSlideScope.vue?vue&type=script&lang=ts"
export * from "./InsertSlideScope.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports